import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({ apidata, columns, searchBy }) {
  const [dataFilter, setDataFilter] = useState("");
  const [monthFilter, setMonthFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  useEffect(() => {
    let filtered = apidata;
    if (dataFilter) {
      filtered = filtered.filter((item) => {
        if (searchBy === "fileName") {
          return (
            item.fileName &&
            item.fileName.toLowerCase().includes(dataFilter.toLowerCase())
          );
        }

        return false;
      });
    }
    if (monthFilter) {
      filtered = filtered.filter(
        (item) =>
          item.report_month &&
          item.report_month.toLowerCase() === monthFilter.toLowerCase()
      );
    }
    setFilteredData(filtered);
    const totalSalarySum = filtered.reduce(
      (sum, item) => sum + (item.total_salary || 0), // Sum salaries from filtered data
      0
    );
  }, [dataFilter, apidata, searchBy, monthFilter]);

  const applyFilter = () => {
    setShowFilterModal(false);
  };

  const removeFilter = () => {
    setMonthFilter("");
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p>No results found.</p>
          </div>
        </div>
      )}
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        apidata={apidata}
        applyFilter={applyFilter}
        removeFilter={removeFilter}
        applyFilters={() => setShowFilterModal(false)}
        removeFilters={() => {
          setShowFilterModal(false);
        }}
        monthFilter={monthFilter}
        setMonthFilter={setMonthFilter}
      />
    </div>
  );
}
